import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabaseClient';
import { logAndThrow } from '@/utils/logging';

/**
 * Ids of the leagues that have at least one group in `season`. Drives the
 * default league of a fresh session (a league with no group has nothing to show).
 */
export function useLeagueIdsWithGroups(season: string | null | undefined, enabled = true) {
  return useQuery<Set<string>>({
    queryKey: ['league-ids-with-groups', season],
    enabled: enabled && !!season,
    staleTime: 30 * 60 * 1000,
    // AppRouter keeps its full-screen loader while this query is loading; the
    // default 3 retries (exponential backoff) would hold it ~7 s on a failure.
    retry: 1,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('league_groups')
        .select('league_id')
        .eq('season', season as string);
      if (error) return logAndThrow('fetch league ids with groups', error, { season });
      return new Set((data ?? []).map((r: { league_id: string | null }) => r.league_id).filter(Boolean) as string[]);
    },
  });
}
